import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitofivejyotilingacab() {



  const cardData = {
    keyword: " Mumbai to 5 Jyotirlinga Cab",

"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to 5 Jyotirlinga cab services, ensuring a smooth, safe, and spiritually fulfilling journey for devotees and pilgrimage groups. This special Jyotirlinga tour covers some of the most sacred Shiva temples across Maharashtra, including Bhimashankar, Trimbakeshwar, Grishneshwar, and other nearby Jyotirlinga destinations depending on your customized itinerary. Whether you are planning a short pilgrimage or a multi-day spiritual yatra, our professional drivers and well-maintained vehicles provide a stress-free travel experience. The Mumbai to Jyotirlinga circuit spans multiple routes across Maharashtra and can be customized based on temple selection and travel duration. We offer flexible booking options including one-way trips, round trips, and full pilgrimage packages with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for individuals, families, and large groups. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Jyotirlinga travel.",

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga",
    "description": "Bhimashankar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva, located in the dense Sahyadri hills. Surrounded by forests, waterfalls, and wildlife sanctuary, it offers a deeply spiritual and nature-filled experience. Devotees visit for blessings and to experience the divine calm atmosphere."
  },
  {
    "title": "Trimbakeshwar Jyotirlinga",
    "description": "Trimbakeshwar Temple near Nashik is one of the most important Jyotirlingas in India, located at the origin of the Godavari River. It is famous for religious rituals like Kaal Sarp Dosh Puja and attracts thousands of devotees seeking spiritual cleansing and blessings."
  },
  {
    "title": "Grishneshwar Jyotirlinga",
    "description": "Grishneshwar Temple near Ellora Caves is the 12th Jyotirlinga and holds immense spiritual importance. Built in traditional Hemadpanthi style, it is a major pilgrimage site often visited along with Ajanta and Ellora caves tours."
  },
  {
    "title": "Aundha Nagnath Jyotirlinga",
    "description": "Aundha Nagnath Temple is one of the ancient Jyotirlingas dedicated to Lord Shiva, located in Hingoli district. It is believed to be established by the Pandavas and is known for its grand architecture and peaceful spiritual surroundings."
  },
  {
    "title": "Parli Vaijnath Jyotirlinga",
    "description": "Parli Vaijnath Temple is a powerful Jyotirlinga dedicated to Lord Shiva as the healer. Devotees believe that prayers here help in curing diseases and bringing health and prosperity. The temple has strong spiritual energy and historical significance."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves are a UNESCO World Heritage Site featuring Hindu, Buddhist, and Jain monuments carved into rock. The Kailasa Temple is the most iconic structure, representing divine craftsmanship and spiritual heritage often included in Jyotirlinga tours."
  },
  {
    "title": "Ajanta Caves",
    "description": "Ajanta Caves are famous for ancient Buddhist paintings and sculptures depicting the life of Buddha. These caves showcase India’s rich spiritual and artistic heritage and are often combined with Jyotirlinga pilgrimage routes."
  },
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi Sai Baba Temple is one of India’s most visited pilgrimage sites. Many Jyotirlinga tour packages include Shirdi darshan, where devotees seek blessings of Sai Baba along with Shiva temples."
  },
  {
    "title": "Nashik Panchavati",
    "description": "Panchavati in Nashik is a sacred site associated with Ramayana, where Lord Rama is believed to have stayed during exile. It is often included in Jyotirlinga tours due to its strong religious significance and proximity to Trimbakeshwar."
  },
  {
    "title": "Aurangabad Spiritual Circuit",
    "description": "Aurangabad serves as a major hub for Jyotirlinga tours, offering access to Grishneshwar Temple, Ellora Caves, and nearby heritage and spiritual destinations, making it an important part of the 5 Jyotirlinga circuit."
  }
],







services: [
  {
    name: "Mumbai to 5 Jyotirlinga Cab",
    description: "Mumbai to 5 Jyotirlinga cab service offers a complete spiritual journey covering the sacred Jyotirlinga temples across Maharashtra. This pilgrimage includes visits to Trimbakeshwar, Bhimashankar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Ideal for devotees, families, and group travelers, this service ensures a peaceful and well-planned yatra. Professional drivers experienced in long routes and temple circuits ensure safe travel. Comfortable vehicles and flexible schedules enhance the experience. It guarantees a smooth and divine journey."
  },
  {
    name: "Mumbai to Jyotirlinga Taxi",
    description: "Mumbai to Jyotirlinga taxi provides reliable and comfortable transportation for devotees planning temple visits. This service is suitable for both single temple trips and complete Jyotirlinga tours. Vehicles are well-maintained and driven by experienced chauffeurs. Door-to-door pickup adds convenience. It ensures a safe and spiritual travel experience."
  },
  {
    name: "Mumbai to Jyotirlinga Cab Service",
    description: "Mumbai to Jyotirlinga cab service is designed for long-distance pilgrimage travel with a focus on comfort and safety. This service is ideal for multi-day temple tours covering different Jyotirlingas. Vehicles are maintained for highway and rural travel. Professional drivers ensure smooth journeys. Flexible travel plans make it convenient. It ensures a reliable pilgrimage experience."
  },
  {
    name: "Mumbai to 5 Jyotirlinga Taxi Service",
    description: "Mumbai to 5 Jyotirlinga taxi service offers a complete travel solution for devotees planning the sacred temple circuit. This service includes multi-day trips with flexible schedules for darshan at each temple. Comfortable vehicles and trained drivers ensure a stress-free journey. It is ideal for family and group travel. It guarantees a well-organized spiritual tour."
  },
  {
    name: "Cab from Mumbai to Jyotirlinga Tour",
    description: "Cab from Mumbai to Jyotirlinga tour provides a personalized travel experience with flexible routes and stops. This service is ideal for devotees who want to plan their journey at their own pace. Clean vehicles and experienced drivers ensure comfort and safety. It offers a peaceful and customizable pilgrimage journey."
  },
  {
    name: "Taxi from Mumbai to Jyotirlinga Yatra",
    description: "Taxi from Mumbai to Jyotirlinga yatra offers convenient and reliable transport for spiritual tours. This service is suitable for pilgrims traveling across multiple temple locations. Drivers are experienced in long-distance routes and temple circuits. Comfortable vehicles ensure a relaxed journey. It ensures a smooth yatra experience."
  },
  {
    name: "Mumbai to Jyotirlinga Cab Booking",
    description: "Mumbai to Jyotirlinga cab booking allows travelers to reserve their pilgrimage vehicle easily. Customers can select vehicle type, travel duration, and route preferences. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning for devotees."
  },
  {
    name: "Mumbai to Jyotirlinga Taxi Booking Online",
    description: "Mumbai to Jyotirlinga taxi booking online provides a quick and convenient way to book your yatra. Customers can compare vehicles, pricing, and packages easily. Secure payment and instant confirmation ensure reliability. It ensures availability during peak pilgrimage seasons."
  },
  {
    name: "Mumbai to Jyotirlinga Cab Price",
    description: "Mumbai to Jyotirlinga cab price varies based on vehicle type, number of days, and travel route. Transparent pricing ensures no hidden charges. Budget-friendly and premium options are available. It helps devotees plan their pilgrimage efficiently. It ensures value-driven travel."
  },
  {
    name: "Mumbai to Jyotirlinga Taxi Fare",
    description: "Mumbai to Jyotirlinga taxi fare is designed to be affordable and flexible for multi-day temple tours. Fare depends on vehicle type and travel duration. Customers receive clear pricing details before booking. It ensures cost-effective pilgrimage travel."
  },
  {
    name: "Mumbai to Jyotirlinga One Way Cab",
    description: "Mumbai to Jyotirlinga one way cab is suitable for travelers visiting specific Jyotirlinga temples without return travel. This service offers flexibility in planning routes and destinations. Comfortable vehicles and experienced drivers ensure safe travel. It is ideal for customized trips."
  },
  {
    name: "Mumbai to Jyotirlinga Round Trip Taxi",
    description: "Mumbai to Jyotirlinga round trip taxi is ideal for complete pilgrimage tours with return travel included. This package covers multiple temples with flexible scheduling. Suitable for families and groups. Professional drivers ensure timely darshan visits. It ensures convenience and efficiency."
  },
  {
    name: "Mumbai to Jyotirlinga Innova Cab",
    description: "Mumbai to Jyotirlinga Innova cab is perfect for families and groups seeking spacious and comfortable travel for multi-day journeys. The vehicle offers ample seating and luggage space. Ideal for long-distance pilgrimage tours. Professional drivers ensure safety. It provides a premium experience."
  },
  {
    name: "Mumbai to Jyotirlinga Ertiga Cab",
    description: "Mumbai to Jyotirlinga Ertiga cab is suitable for small groups and families looking for an affordable yet comfortable ride. This vehicle offers good mileage and seating comfort. Ideal for budget-friendly pilgrimage travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Jyotirlinga Sedan Cab",
    description: "Mumbai to Jyotirlinga sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for long journeys. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Jyotirlinga SUV Taxi",
    description: "Mumbai to Jyotirlinga SUV taxi provides extra space and comfort for group travel and long-distance temple tours. SUVs perform well on highways and rural roads. This option is ideal for families and large groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Jyotirlinga Tour Package from Mumbai",
    description: "Jyotirlinga tour package from Mumbai offers a complete and well-planned pilgrimage covering multiple sacred temples. This package includes vehicle, driver, and flexible itinerary for darshan. Ideal for families and groups. Comfortable vehicles and experienced drivers ensure a smooth journey. It guarantees a fulfilling spiritual experience."
  },
  {
    name: "Best Jyotirlinga Cab Service Mumbai",
    description: "Best Jyotirlinga cab service Mumbai ensures a premium travel experience with well-maintained vehicles and professional drivers. This service focuses on safety, punctuality, and comfort for long-distance pilgrimage tours. Multiple vehicle options are available to suit different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable yatra."
  }
],

tableData: [
  ["Mumbai to 5 Jyotirlinga Cab", "Mumbai to Jyotirlinga Taxi"],
  ["Mumbai to Jyotirlinga Cab Service", "Mumbai to 5 Jyotirlinga Taxi Service"],
  ["Cab from Mumbai to Jyotirlinga Tour", "Taxi from Mumbai to Jyotirlinga Yatra"],
  ["Mumbai to Jyotirlinga Cab Booking", "Mumbai to Jyotirlinga Taxi Booking Online"],
  ["Mumbai to Jyotirlinga Cab Price", "Mumbai to Jyotirlinga Taxi Fare"],
  ["Mumbai to Jyotirlinga One Way Cab", "Mumbai to Jyotirlinga Round Trip Taxi"],
  ["Mumbai to Jyotirlinga Innova Cab", "Mumbai to Jyotirlinga Ertiga Cab"],
  ["Mumbai to Jyotirlinga Sedan Cab", "Mumbai to Jyotirlinga SUV Taxi"],
  ["Jyotirlinga Tour Package from Mumbai", "Best Jyotirlinga Cab Service Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Complete 5 Jyotirlinga Darshan Package",
    WhyChoosedescription: "Royal Route Cabs offers a well-planned Mumbai to 5 Jyotirlinga cab service covering major Jyotirlinga temples like Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath."
  },
  {
    WhyChooseheading: "Experienced Pilgrimage Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with long religious routes and temple circuits, ensuring smooth navigation and timely darshan at each Jyotirlinga."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and complete trip cost without hidden charges."
  },
  {
    WhyChooseheading: "Flexible Multi-Day Tour Plans",
    WhyChoosedescription: "We offer customizable 3 to 5 day tour packages for Mumbai to 5 Jyotirlinga yatra based on your comfort and schedule."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, regularly serviced, and maintained to ensure a comfortable long-distance pilgrimage journey."
  },
  {
    WhyChooseheading: "24/7 Pickup & Travel Flexibility",
    WhyChoosedescription: "Our cab services are available 24/7, allowing flexible departure from Mumbai as per your travel plan."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options for Groups",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for family and group travel."
  },
  {
    WhyChooseheading: "Trusted Religious Tour Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Mumbai to 5 Jyotirlinga cab service due to organized trips, reliable drivers, and comfortable journeys."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to 5 Jyotirlinga cab service?", answer: "Yes, Royal Route Cabs offers complete 5 Jyotirlinga cab tour packages from Mumbai." },
  { question: "Which Jyotirlingas are covered in this tour?", answer: "The tour usually covers Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath." },
  { question: "How many days are required for this yatra?", answer: "Typically, 3 to 5 days are required to complete the 5 Jyotirlinga darshan comfortably." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for this trip?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize the tour package?", answer: "Yes, we provide fully customizable tour plans based on your preferences and travel schedule." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during peak pilgrimage seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kiran Joshi",
    feedback: "Our spiritual journey from Mumbai to the 5 Jyotirlinga tour with Royal Route Cabs was truly comfortable. The entire trip was well-planned and the driver was very cooperative throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Alka Deshpande",
    feedback: "We had a very smooth and memorable experience visiting the 5 Jyotirlinga from Mumbai. Royal Route Cabs provided a clean vehicle and ensured a safe, hassle-free pilgrimage.",
    rating: 5
  }
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to 5 Jyotirlinga Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-5-jyotirlinga-cab.jpg", // replace if needed
  "description": "Book Mumbai to 5 Jyotirlinga cab tour with Royal Route Cabs for a spiritual and comfortable journey. Cover major Jyotirlinga destinations with one-way and round-trip options in sedan, SUV, Innova, and luxury cars. Safe, reliable, and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-5-jyotirlinga-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to 5 Jyotirlinga Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to 5 Jyotirlinga cab tour with Royal Route Cabs. Spiritual yatra with sedan, SUV, Innova & luxury cars. Safe, comfortable & 24x7 available service."
  />

  <meta
    name="keywords"
    content="mumbai to 5 jyotirlinga cab, mumbai to jyotirlinga taxi, mumbai to jyotirlinga cab service, mumbai to 5 jyotirlinga taxi service, cab from mumbai to jyotirlinga tour, taxi from mumbai to jyotirlinga yatra, mumbai to jyotirlinga cab booking, mumbai to jyotirlinga taxi booking online, mumbai to jyotirlinga cab price, mumbai to jyotirlinga taxi fare, mumbai to jyotirlinga one way cab, mumbai to jyotirlinga round trip taxi, mumbai to jyotirlinga innova cab, mumbai to jyotirlinga ertiga cab, mumbai to jyotirlinga sedan cab, mumbai to jyotirlinga suv taxi, jyotirlinga tour package from mumbai, best jyotirlinga cab service mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitofivejyotilingacab;